import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class SessionHandler {
    public prevUrl:any;
	private storageSub= new Subject<string>();

	constructor() { }
	watchStorage(): Observable<any> {
		return this.storageSub.asObservable();
	  }
	saveItem(key,value){
		localStorage.setItem(key,value);
		this.storageSub.next('added');

	}
	
	getItem(key){;
		return localStorage.getItem(key);
	}

	removeItem(key){
		localStorage.removeItem(key);
		this.storageSub.next('removed');

	}
	
	clearAllItems(){
		localStorage.clear();
		this.storageSub.next('removedAll');

	}
	
	setRedirectionUrl(prevUrl: any) {
    	this.prevUrl = prevUrl;
  	}

  	getRedirectionUrl() {
    	return this.prevUrl;
  	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/services/session-handler.service.ts